import { useMemo } from 'react';
import classNames from 'classnames';
import { Section } from '@/components';
import { items } from './items';

type AtencionAlCiudadanoProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-atencion-ciudadano';

export const AtencionAlCiudadano = ({ className }: AtencionAlCiudadanoProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	return (
		<Section className={wrapperClassName} title="Atencion al ciudadano">
			<div className={`${classNameComponent}__grid`}>
				{items.map(({ img: Icon, title, description }) => (
					<article key={title} className={`${classNameComponent}__card`}>
						<div className={`${classNameComponent}__icon-wrap`}>
							<Icon className={`${classNameComponent}__icon`} role="img" aria-label={title} />
						</div>

						<div className={`${classNameComponent}__content`}>
							<h3 className={`${classNameComponent}__title`}>{title}</h3>
							<p className={`${classNameComponent}__desc`}>{description}</p>
						</div>
					</article>
				))}
			</div>
		</Section>
	);
};
